// extracted by mini-css-extract-plugin
var _1 = "Box-modulebox__T8Mz4";
var _2 = "Box-modulefullScreen__WxigX";
var _3 = "Box-modulelSize__cUhlZ";
var _4 = "Box-modulemSize__V6tsr";
var _5 = "Box-modulesSize__mUvqI";
var _6 = "Box-modulexlSize__rPgbL";
export { _1 as "box", _2 as "fullScreen", _3 as "lSize", _4 as "mSize", _5 as "sSize", _6 as "xlSize" }
